import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { UI_KIT_TEXT_TYPOGRAPHY } from '../constants';
import QuizGameCard from '../quiz-game-card/quiz-game-card';
import { Quiz } from '../quiz/typings';
import Text from '../text/text';

import { QuizListMoreButton } from './__more-button/quiz-list__more-button';
import { getDefaultCardImageSrcSet, getShowcaseQuizzesLimit, getUserCardImageSrcSet } from './selectors';

import './quiz-list.scss';

interface Props {
    title: string;
    quizzes: Quiz[];
    onQuizDeleteClick?: (quiz: Quiz) => void;
    onQuizEditClick?: (quiz: Quiz) => void;
    onQuizPreviewClick?: (quiz: Quiz) => void;
    onStartGame: (quiz: Quiz) => void;
    beforeCards?: React.ReactNode;
    isCustom?: boolean;
    cardImgSrcSet?: Record<string, string>;
}

export const QuizList = (props: Props) => {
    const {
        title,
        quizzes,
        onQuizDeleteClick,
        onQuizEditClick,
        onQuizPreviewClick,
        onStartGame,
        isCustom,
        cardImgSrcSet,
        beforeCards = null,
    } = props;

    const showcaseQuizzesLimitByDefault = useSelector(getShowcaseQuizzesLimit);

    const defaultImgSrcSet = useSelector(isCustom ? getUserCardImageSrcSet : getDefaultCardImageSrcSet);
    const imgSrcSet = { ...defaultImgSrcSet, ...cardImgSrcSet };

    const [showcaseQuizzesLimit, setShowcaseQuizzesLimit] = useState(
        beforeCards ? showcaseQuizzesLimitByDefault - 1 : showcaseQuizzesLimitByDefault
    );

    const handleMoreButtonClick = () => {
        setShowcaseQuizzesLimit(Infinity);
    };

    return (
        <div className="quiz-list">
            <Text className="quiz-list__title" typography={UI_KIT_TEXT_TYPOGRAPHY.headlineMMedium}>
                {title}
            </Text>
            <div className="quiz-list__cards">
                {beforeCards}
                {quizzes.slice(0, showcaseQuizzesLimit).map((quiz) => (
                    <QuizGameCard
                        imgSrcSet={imgSrcSet}
                        key={quiz.id}
                        onQuizDeleteClick={() => onQuizDeleteClick?.(quiz)}
                        onQuizEditClick={() => onQuizEditClick?.(quiz)}
                        onQuizPreviewClick={() => onQuizPreviewClick?.(quiz)}
                        onStartGame={() => {
                            onStartGame(quiz);
                        }}
                        shouldShowMenu={isCustom}
                        slidesCount={quiz.questions.length}
                        title={quiz.title}
                    />
                ))}
            </div>
            {quizzes.length > showcaseQuizzesLimit && <QuizListMoreButton onClick={handleMoreButtonClick} />}
        </div>
    );
};
